import styled from 'styled-components';
import { NotificationContainer } from '../NotificationContainer';

const StyledNotificationContainer = styled(NotificationContainer)`
	background-color: #ffffff;
`;

export { StyledNotificationContainer };
